import { useQueryClient, useMutation, useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { http } from "../../../utils";
import { dataTableParamsBuilder } from "../../../utils/data-table-params-builder";
import { usePaginationQuery } from "../../../utils/hooks";

function fetchReviewList(params, sort) {
  const baseUrl = window.location.origin;
  const endpointUrl = new URL("/admin/product-reviews", baseUrl);

  if (params.status) {
    endpointUrl.searchParams.append("status", params.status);
  }

  if (params.division) {
    endpointUrl.searchParams.append("division", params.division);
  }

  if (params.productGroupName) {
    endpointUrl.searchParams.append(
      "productGroupName",
      params.productGroupName
    );
  }

  if (sort.orderBy) {
    endpointUrl.searchParams.append("sort", sort.orderBy);
  }

  if (params.from) {
    endpointUrl.searchParams.append("from", params.from);
  }
  if (params.to) {
    endpointUrl.searchParams.append("to", params.to);
  }

  if (params.contents) {
    endpointUrl.searchParams.append("contents", params.contents);
  }

  dataTableParamsBuilder({
    searchParams: endpointUrl.searchParams,
    filterValues: [params.order],
    ...params,
  });

  return http(endpointUrl.toString().replace(baseUrl, ""));
}

export function useReviewList(params = {}, sort = {}) {
  return usePaginationQuery(
    [
      "review",
      params.status,
      params.division,
      params.productGroupName,
      sort.orderBy,
      params.from,
      params.to,
      params.contents,
    ],
    (paginationState) =>
      fetchReviewList({ ...params, ...paginationState }, sort)
  );
}
async function addReview(formData) {
  const data = await http(`/admin/product-reviews`, {
    data: formData,
  });
  return data;
}

export function useAddReview() {
  const queryClient = useQueryClient();

  return useMutation(addReview, {
    onSuccess: () => {
      queryClient.refetchQueries(["product-reviews"]);
    },
  });
}

export function useUpdateReview() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  return useMutation(
    async (data) => {
      const { id, ...payload } = data;
      const res = await http(`/admin/product-reviews/${id}`, {
        method: "PUT",
        data: payload,
      });
      return res;
    },
    {
      onSuccess: async (res) => {
        if (res !== undefined) {
          await queryClient.invalidateQueries(["product-reviews"]);
          setTimeout(() => {
            navigate("/bulletin-board/");
          }, 1500);
        }
      },
    }
  );
}

async function deleteReview(id) {
  const data = await http(`/admin/-inquiry/${id}`, {
    method: "DELETE",
  });

  return data;
}

export function useDeleteReview() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation(deleteReview, {
    onSuccess: () => {
      queryClient.invalidateQueries(["product-reviews"]);
      setTimeout(() => {
        navigate("/bulletin-board");
      }, 1500);
    },
  });
}

export async function fetchReviewDownload() {
  const { data } = await http(`/admin/product-reviews`, {
    responseType: "blob",
  });

  return data;
}

export function useReviewDownload() {
  const { data, ...raResult } = useQuery(["product-reviews-download"], () =>
    fetchReviewDownload()
  );

  return {
    ...raResult,
    data: data ?? {},
  };
}
